import { render } from "./StartSurvey.vue?vue&type=template&id=d50364ca"
import script from "./StartSurvey.vue?vue&type=script&lang=js"
export * from "./StartSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__